/**
 * The app's pending state: what a screen shows while it does not yet know
 * enough to show anything else (R22 T10).
 *
 * **This component only exists because the app is client-rendered now.** On the
 * Next host the caller was resolved and the page's data fetched before the
 * first byte left the server, so a screen never existed in a state of not
 * knowing. Here it does, on every cold load, and pretending otherwise is how a
 * signed-in member gets bounced to a log-in screen for half a second.
 *
 * Deliberately quiet: no spinner and no words. A cold `/me` usually answers
 * inside a couple of hundred milliseconds, and a spinner that appears and
 * vanishes that fast reads as a glitch rather than as progress. The skeleton
 * holds the layout so nothing jumps when the real content lands.
 *
 * Motion collapses under `prefers-reduced-motion` through the shared stylesheet
 * (design system §7), so there is nothing to switch off here.
 */
export function ScreenPending() {
  return (
    <div
      className="mx-auto w-full max-w-5xl grow px-4 py-10 sm:px-6"
      role="status"
      aria-busy="true"
    >
      {/* The only text is for a screen reader: sighted users get the skeleton. */}
      <span className="sr-only">Loading</span>
      <div className="h-8 w-56 animate-pulse rounded-lg bg-line/60" />
      <div className="mt-6 space-y-3">
        <div className="h-24 animate-pulse rounded-xl bg-line/40" />
        <div className="h-24 animate-pulse rounded-xl bg-line/30" />
        <div className="h-24 animate-pulse rounded-xl bg-line/20" />
      </div>
    </div>
  );
}
